import { FC, useEffect } from "react";

import { GetStaticProps } from "next";
import { useRouter } from "next/router";

import { ROUTES } from "@utils/constants";

export const getStaticProps: GetStaticProps = () => ({
  props: { _escapeMiddleware: true, _nextI18Next: {} },
});

const EmptyPage: FC = () => {
  const { replace } = useRouter();
  useEffect(() => {
    replace(ROUTES.NOT_FOUND);
  }, [replace]);

  return null;
};
export default EmptyPage;
